import React from 'react';
import { useEffectOnce } from 'react-use';

import { authenticationSession } from '@/lib/authentication-session';
import { socket } from '@/lib/socket-client';
import { scheduleProactiveTokenRefresh } from '@/lib/token-refresh';

const SocketContext = React.createContext<typeof socket>(socket);

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const token = authenticationSession.getToken();
  useEffectOnce(() => {
    if (!token) {
      socket.disconnect();
      return undefined;
    }
    socket.auth = { token };
    if (!socket.connected) {
      socket.connect();
    }
    // Keeps the token fresh for as long as this tab stays open, independent
    // of any HTTP call: a builder tab can run over an hour on socket events
    // alone (GENERATE_FLOW, step/flow tests) and never hit the HTTP-401 path.
    return scheduleProactiveTokenRefresh();
  });

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => React.useContext(SocketContext);
